import React, { Component } from 'react';

class Wrapper extends Component {
    render() {
        return (
            <ul className="profile-wrapper row">
                { this.props.title && <h3 className="h3">{ this.props.title }</h3> }
                { this.props.children }
            </ul>
        );
    };
}

export default Wrapper;



// WEBPACK FOOTER //
// src/client/components/common/elements/Wrapper.js